/* HTN: enhance Bundle Ninja promo box countdown (draft 2026-10-20). Reads end time from the app's data-target-at. */
(function(){
  var TZ='Australia/Melbourne';
  function fmtEnd(d){
    try{
      var p={};new Intl.DateTimeFormat('en-AU',{timeZone:TZ,weekday:'long',day:'numeric',month:'short',hour:'numeric',minute:'2-digit',hour12:false}).formatToParts(d).forEach(function(x){p[x.type]=x.value});
      var h=+p.hour,m=+p.minute,t;
      if((h===23&&m>=59)||(h===0&&m===0)||h===24)t='midnight';
      else{var hh=h%12||12;t=hh+(m?':'+p.minute:'')+(h<12?'am':'pm');}
      // if exactly 00:00, "midnight" belongs to the previous day
      if((h===0||h===24)&&m===0){d=new Date(d.getTime()-60000);return fmtEnd(d);}
      return p.weekday+' '+p.day+' '+p.month+', '+t;
    }catch(e){return d.toLocaleString();}
  }
  function fmtShort(d){ // d/m/yyyy in Melbourne, for fixing app badge text
    var p={};new Intl.DateTimeFormat('en-AU',{timeZone:TZ,day:'numeric',month:'numeric',year:'numeric'}).formatToParts(d).forEach(function(x){p[x.type]=x.value});
    return p.day+'/'+p.month+'/'+p.year;
  }
  function pad(n){return n<10?'0'+n:''+n}
  function enhance(src){
    if(src.classList.contains('htn-cd-src'))return;
    var ta=src.getAttribute('data-target-at'); if(!ta||src.getAttribute('data-mode')==='starts_in')return;
    var end=new Date(ta); if(isNaN(end))return;
    var card=src.closest('.bdp-card');
    // Safe text tidy: keep the app's copy but make the badge date match the real end date, fix known typo.
    if(card){
      var b=card.querySelector('.bdp-badge'); var real=fmtShort(new Date(end.getTime()-60000));
      if(b&&/\b\d{1,2}\/\d{1,2}\/\d{4}\b/.test(b.textContent)) b.textContent=b.textContent.replace(/\b\d{1,2}\/\d{1,2}\/\d{4}\b/g,real);
      var s=card.querySelector('.bdp-sub'); if(s&&/\bDiscout\b/.test(s.textContent)) s.textContent=s.textContent.replace(/\bDiscout\b/g,'Discount');
    }
    var w=document.createElement('div');w.className='htn-promo-end';
    w.innerHTML='<div class="htn-promo-end__when"><span class="htn-promo-end__lbl">Offer ends</span><span class="htn-promo-end__date"></span></div>'+
      '<ul class="htn-promo-cd" aria-hidden="true"><li><b data-u="d">0</b><span>Days</span></li><li><b data-u="h">00</b><span>Hrs</span></li><li><b data-u="m">00</b><span>Mins</span></li><li><b data-u="s">00</b><span>Secs</span></li></ul>';
    w.querySelector('.htn-promo-end__date').textContent='Ends '+fmtEnd(end);
    src.classList.add('htn-cd-src');
    src.parentNode.insertBefore(w,src.nextSibling);
    var u={};['d','h','m','s'].forEach(function(k){u[k]=w.querySelector('[data-u="'+k+'"]')});
    function tick(){
      var diff=end.getTime()-Date.now();
      if(diff<=0){w.remove();clearInterval(t);return;}
      var s=Math.floor(diff/1000);
      u.d.textContent=Math.floor(s/86400);u.h.textContent=pad(Math.floor(s%86400/3600));u.m.textContent=pad(Math.floor(s%3600/60));u.s.textContent=pad(s%60);
      w.classList.toggle('is-last-day',diff<86400000);
    }
    tick();var t=setInterval(tick,1000);
  }
  function scan(root){(root||document).querySelectorAll('.bundle-deals-promo-root .bdp-countdown').forEach(enhance)}
  function init(){
    scan();
    document.querySelectorAll('.bundle-deals-promo-root').forEach(function(r){
      new MutationObserver(function(){scan(r)}).observe(r,{childList:true,subtree:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
